import { render, staticRenderFns } from "./recordModal.vue?vue&type=template&id=9f86e068&scoped=true"
import script from "./recordModal.vue?vue&type=script&lang=js"
export * from "./recordModal.vue?vue&type=script&lang=js"
import style0 from "./recordModal.vue?vue&type=style&index=0&id=9f86e068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f86e068",
  null
  
)

export default component.exports